module.exports = __webpack_public_path__ + "img/pesanan.98414035.jpg";